import { Component, ViewEncapsulation } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { map, filter } from 'rxjs/operators';
import { UserDto } from './dtos/user-dto';
import { AuthorizationEnum } from './enums/authorization-enum';
import { AuthenticationService } from './core/services/AuthenticationService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  deactivateSideNav: Observable<any>;
  showButton = false;
  public authorizationType: AuthorizationEnum;
  public authorizationEnum = AuthorizationEnum;
  screenWidth: number;
  showSidenav:boolean = true;
  showSubmenu = false;
  language: string = 'es-Mx';

  constructor(private breakpointObserver: BreakpointObserver, private router: Router,
    private route: ActivatedRoute, private authenticationService: AuthenticationService,
    private translateService: TranslateService) {

    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth;
    };

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((route: ActivatedRoute) => {
      this.deactivateSideNav = this.route.snapshot.firstChild.data ? this.route.snapshot.firstChild.data.deactivateSideNav : false;
      if (!this.deactivateSideNav) {
        this.showButton = true;
        this.getUser();
      }
    });
  }

  ngOnInit(): void {

  }

  title = 'SEKO LOGISTIC';

  getUser() {
    let userStorage = localStorage.getItem('currentUser');
    if (userStorage) {
      let user: UserDto = JSON.parse(userStorage);
      if (user) {
        this.authorizationType = user.auth;
      }
    }
  }

  logOut() {
    // reset login status
    this.authenticationService.logout();
    location.reload(true);

  }

  changelanguage(){
    if(this.language == 'es-Mx'){
      this.language = 'en-Us';
      this.translateService.setDefaultLang(this.language);
      this.translateService.use(this.language);
    }else{
      this.language = 'es-Mx';
      this.translateService.setDefaultLang(this.language);
      this.translateService.use(this.language);
    }
  }

}
